import React from 'react'
import NavBar from './NavBar'
import Notification from '../General/Notification'
import TransactionCard from './TransactionCard'
import FloatingIcon from '../General/FloatingIcon'
import NavbarJ from './NavbarJ1'

function CopyMain() {
  return (
    <div>
      <NavBar/>  
      <Notification/>
      <TransactionCard/>
      <FloatingIcon/>
      <NavbarJ/>
      
    </div>
  )
}

export default CopyMain